"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cluster_factory_1 = require("./cluster-factory");
var HierarchicalClustering = /** @class */ (function () {
    function HierarchicalClustering(objects, linkage) {
        var _this = this;
        this.clusterFactory = new cluster_factory_1.ClusterFactory();
        this.objects = objects;
        this.linkage = linkage;
        this.clusters = this.objects.map(function (e) { return _this.clusterFactory.createLeafCluster(e); });
        this.linkageValues = [];
        this.initializeLinkageValues();
    }
    HierarchicalClustering.prototype.cluster = function () {
        var _loop_1 = function () {
            // Merge cluster with lowest distance
            this_1.linkageValues.sort(function (e1, e2) { return e1.distance - e2.distance; });
            var _a = this_1.linkageValues[0], c1 = _a.c1, c2 = _a.c2, value = _a.distance;
            var merged = this_1.clusterFactory.createMergedCluster(c1, c2, value);
            // Remove merged cluster from the cluster and linkage values list
            this_1.clusters = this_1.clusters.filter(function (e) { return e.id !== c1.id && e.id !== c2.id; });
            this_1.linkageValues = this_1.linkageValues.filter(function (e) { return e.c1.id !== c1.id && e.c1.id !== c2.id && e.c2.id !== c1.id && e.c2.id !== c2.id; });
            // Calculate and store distances to the merged cluster
            for (var _i = 0, _b = this_1.clusters; _i < _b.length; _i++) {
                var cluster = _b[_i];
                this_1.linkageValues.push({
                    c1: cluster,
                    c2: merged,
                    distance: this_1.linkage.calculate(cluster, merged),
                });
            }
            this_1.clusters.push(merged);
        };
        var this_1 = this;
        while (this.clusters.length > 1) {
            _loop_1();
        }
        return this.clusters[0];
    };
    HierarchicalClustering.prototype.initializeLinkageValues = function () {
        for (var i = 0; i < this.clusters.length; i++) {
            for (var j = i + 1; j < this.clusters.length; j++) {
                var c1 = this.clusters[i];
                var c2 = this.clusters[j];
                var distance = this.linkage.calculate(c1, c2);
                this.linkageValues.push({ c1: c1, c2: c2, distance: distance });
            }
        }
    };
    return HierarchicalClustering;
}());
exports.HierarchicalClustering = HierarchicalClustering;
